import utils from '../util'

export default {
  formatTime: (timestamp, format) => {
    return utils.formatTime(timestamp, format)
  },

  /**
   * 把单位为分的价格单位换算为元
   * @param price 价格，单位为 分
   * @returns price 价格，单位为 元
   */
  formatPrice (price) {
    if (!price) return 0

    return price / 100
  }
}
